export const APIConfig = {
    getLabInventory: () => "labInventory/getAll",
    getInventoryCategory: () => "inventoryCategory/getAll",
    inventoryCategory: () => "inventoryCategory",
    getInventoryCategoryDetails: () => "inventoryCategory?id=",
    inventoryType: () => "inventoryType",
    getInventoryType: () => "inventoryType/getAll",
    getInventoryTypeDetails: () => "inventoryType?id=",
    inventoryBundle: () => "inventoryBundle",
    corsica: () => "DeployedCorsica",
    getAllCorsica: () => "DeployedCorsica/GetAll",
    getCorsicaDetails: () => "DeployedCorsica?bladeId=",
    CorsicaEdit: (localID: number | undefined, bladeId: number | undefined) =>
        `DeployedCorsica?id=${localID}&bladeId=${bladeId}`,
    getInventoryBundle: () => "inventoryBundle/getAll",
    getInventoryBundleDetails: () => "inventoryBundle?id=",
    powerLimit: () => "powerLimit",
    getPowerLimit: () => "powerLimit/getAll",
    getPowerLimitDetails: () => "powerLimit?id=",
    getLabStatus: () => "inventoryStatus/getall",
    getLeaseStatus: () => "inventoryLeaseStatus/getAll",
    getInventoryAction: () => "inventoryAction/getAll",
    getInventoryTool: () => "tool/getAll",
    getInventoryLeaseOwner: () => "inventoryLease/getAllUsers",
    getLabInventoryDetails: () => "labInventory?id=",
    getTaiwanDetails: () => "LabInventory/GetTaiwanInventoryById?id=",
    getCheckoutSummary: () => "labInventory/getCheckoutSummary?id=",
    getExcel: () => "labInventoryHistory/export",
    getLabInventoryExcel: () => "labInventory/export",
    getHistory: () => "labInventoryHistory/getall",
    labInventory: () => "labInventory",
    getInventoryLease: () => "inventoryLease",
    getProjectall: () => "inventoryProject/getAll",
    getAudit: () => "labInventoryAudit/getall",
    getAuditExcel: () => "labInventoryAudit/export",
    getRackAudit: () => "RackAudit/getall",
    getRackAuditExcel: () => "RackAudit/export",
    getCurrency: () => "currency/getAll",
    restoreItem: () => "labInventoryHistory/activate?id=",
    GetIsValidOwner: () => "labInventory/getIsValidOwner",
    getAutoNumber: () => "autoNumbers/getByName?name=",
    getUserGroups: () => "userGroup/getAll",
    getHwReport: () => "HWReport/getAll",
    getUserGroupsByAlias: () => "userGroup/getgroupsbyuseralias",
    getUsersBySG: () => "userGroup/getUsersBySG",
    getLabInventoryImportData: () => "ImportData/ImportLabInventoryData",
    multipleCheckIn: () => "MultipleAction/Checkin",
    multipleCheckOut: () => "MultipleAction/Checkout",
    multipleTransfer: () => "MultipleAction/Transfer",
    multipleExtend: () => "MultipleAction/Extend",
    multipleValidate: () => "MultipleAction/Validate",
    getSwitchImportData: () => "ImportData/ImportSwitch",
    getRackImportData: () => "ImportData/ImportRackInfo",
    getChassisManagerData: () => "CMInfo",
    getChassisManagerByRack: () => "CMInfo/GetCMByRack",
    getRackManagerData: () => "RMInfo",
    getRackManagerByRack: () => "RMInfo/GetRMByRack",
    getRackData: () => "RackInfo",
    getRackToolKitConfigExport: () => "RackInfo/GetRackToolKitConfig?rackId=",
    getRackElevation: () => "RackInfo/GetRackElevation?rackId=",
    getRackBladeElevation: () => "RackInfo/GetRackBladeElevation?rackId=",
    rackbulkUpdate: () => "RackInfo/RackBulkUpdateAsync",
    getRackLevel: () => "RackInfo/GetRackLevelElevation?rackId=",
    getRDPFile: () => "RackInfo/GetRDPFile?bladeId=",
    getUserActivityLogs: () => "Activity/ActivityLogs",
    getUserActivityHits: () => "Activity/ActivtyHits",
    swLicense: () => "swLicense",
    getSwLicense: () => "swLicense/getAll",
    getSwLicenseDetails: () => "swLicense?id=",
    serviceContract: () => "serviceContract",
    serviceContractDocument: () => "serviceContractDocument",
    getServiceContract: () => "serviceContract/getAllServiceContract",
    getServiceContractDetails: () => "serviceContract?id=",
    document: () => "document",
    inventoryStatus: () => "inventoryStatus",
    getInventoryStatusDetails: () => "inventoryStatus?id=",
    getPMDUPower: () => "PMDUPowerMeter",
    getAllDimms: () => "DeployedDimms/GetAllDeployeddimmAsync",
    getDimmsByBladeId: () =>
        "Deployeddimms/GetAllDeployeddimmByBladeAsync?bladeId=",
    getDimmsByBladeAndDimmsId: () => "DeployedDimms/GetDeployeddimmByBladeAndDimIdAsync?bladeId=",
    getAllBlades: () => "Blade/GetAll",
    getBladesExport: (machineType: number | null, bladeId: number) =>
        `Blade/Export?machineType=${machineType}&bladeId=${bladeId}`,
    getToolconfigExport: () => "Blade/GetBladeToolKitConfig?bladeId=",
    getDetailsByBladeId: () => "Blade/GetBladeBasicDetailsAsync?id=",
    getBladeLogonHistory: () => "Blade/GetBladeLogonHistoryAsync?bladeId=",
    getBladePowerMonthlyAsync: () => "Blade/GetBladePowerMonthlyAsync?bladeId=",
    enableBladeMaintenance: () => "Blade/EnableBladeMaintainance?bladeId=",
    getBladeTempMonthlyAsync: () => "Blade/GetBladeTempMonthlyAsync?bladeId=",
    getBladeCurrentPowerJson: (rmIp: string, bladeId: number | null) =>
        `Blade/GetBladeCurrentPowerJson?rmIp=${rmIp}&bladeId=${bladeId}`,
    getBladeCurrentThermalJson: (rmIp: string, bladeId: number | null) =>
        `Blade/GetBladeCurrentThermalJson?rmIp=${encodeURIComponent(rmIp)}&bladeId=${bladeId}`,
    disableBladeMaintenance: () => "Blade/DisableBladeMaintainance?bladeId=",
    getRDPfile: () => "RackInfo/GetRDPFile?bladeId=",
    getBladeLogs: () => "Blade/GetBladeLogs?bladeId=",
    resetLogs: () => "Blade/ResetLog?bladeId=",
    getbladeNotes: () => "Blade/GetBladeNotesAsync?bladeId=",
    addNotes: () => "Blade/AddOrUpdateBladeNotes",
    addRackNotes: () => "NotesHistory",
    getRackNotes: () => "NotesHistory",
    editLeaseReason: () => "Blade/UpdateBladeLeaseReason",
    scanIndividualBlade: () => "Scan/ScanIndividualBlade",
    getAllDisks: () => "Deployedphysdisk/GetAllDeployedphysdiskAsync",
    getDisksByBladeId: () =>
        "Deployedphysdisk/GetAllDeployedphysdiskByBladeAsync?bladeId=",
    getDisksByBladeAndDiskId: () => "Deployedphysdisk/GetDeployedphysdiskByBladeAndDiskIdAsync?bladeId=",
    getAllNics: () => "Deployednic/GetAllDeployedNicsAsync",
    getNicsByBladeId: () => "Deployednic/GetAllDeployedNicsByBladeAsync?bladeId=",
    getNicsByBladeAndNicsId: () => "Deployednic/GetDeployedNicsByBladeAndNicsIdAsync?bladeId=",
    getPMDUPowerDetails: () => "PMDUPowerMeter?rackid=",
    getCurrentRMPowerDetails: () =>
        "PMDUPowerMeter/GetCurrentRMPowerInfo?rackId=",
    getCurrentSARMPowerDetails: () =>
        "PMDUPowerMeter/GetCurrentSARMPowerInfo?rackId=",
    getWeeklyPMDUPowerMeterByRack: () =>
        "PMDUPowerMeter/GetWeeklyPMDUPowerMeterByRack?rackId=",
    getMonthlyRMPowerInfoByRack: () =>
        "PMDUPowerMeter/GetMonthlyRMPowerInfo?rackId=",
    getMonthlySARMPowerInfoByRack: () =>
        "PMDUPowerMeter/GetMonthlySARMPowerInfo?rackId=",
    getSARMPowerMeterByRack: () =>
        "PMDUPowerMeter/GetSARMPowerMeterByRackId?rackId=",
    GetPMDUPowerMeterByRack: () =>
        "PMDUPowerMeter/GetPMDUPowerMeterByRackId?rackId=",
    getPMDUPowerExport: () => "PMDUPowerMeter/Export",
    getInfraDeviceData: () => "InfraDevice",
    datacenter: () => "dc",
    getDatacenter: () => "dc/getAll",
    getDatacenterDetails: () => "dc?id=",
    getDatacenterExport: () => "DC/GetDCLayoutExport?dcId=",
    getRackOrganizer: () => "dc/getRackOrganizer?id=",
    getAllPhysBlades: () => "Blade/GetPhysBlades",
    getAllPhysRacks: () => "Blade/GetPhysRacks",
    getAllPhysBladeOwners: () => "Blade/GetPhysBladeStatOwners",
    userGroups: () => "userGroup",
    getSecurityGroupDetails: () => "usergroup?id=",
    getJbod: () => "jbods/getAll",
    getJbodDetails: () => "jbods/GetJBOdBlade?id=",
    getJbodLogs: () => "jbods/GetJBOdBladeLogs?bladeId=",
    getAllProcs: () => "DeployedProc/GetAllDeployedProcsAsync",
    getProcsByBladeId: () =>
        "DeployedProc/GetAllDeployedProcsByBladeAsync?bladeId=",
    getProcsByBladeAndProcsId: () => "DeployedProc/GetAllDeployedProcsByBladeAndDiskIdAsync?bladeId=",
    getAllTPMs: () => "DeployedTPMs/GetAllDeployedTpmsAsync",
    getTpmsByBladeId: () =>
        "DeployedTPMs/GetAllDeployedTpmsByBladeAsync?bladeId=",
    getTPMsByBladeAndTPMsId: () => "DeployedTPMs/GetDeployedTpmsByBladeAndTpmIdAsync?bladeId=",
    getAllFPGAs: () => "DeployedFPGAs/GetAllDeployedfpgaAsync",
    getFPGAsByBladeId: () =>
        "DeployedFPGAs/GetAllDeployedfpgasByBladeAsync?bladeId=",
    getFpgasByBladeAndFpgasId: () => "DeployedFPGAs/GetDeployedFpgasByBladeAndFpgasIdAsync?bladeId=",
    pdu: () => "pdu",
    getPdu: () => "pdu/getAll",
    getPduDetails: () => "pdu?id=",
    baasRaas: () => "BaasRaas",
    baasRaasExport: () => "BaasRaas/Export",
    baasRaasReservationExport: () => "BaasRaas/ExportReservation",
    bladeExport: () => "Blade/Download",
    rackExport: () => "RackInfo/Export",
    infradeviceExport: () => "InfraDevice/Export",
    RMInfoExport: () => "RMInfo/Export",
    cmExport: () => "CMInfo/Export",
    jbodExport: () => "JBODs/Export",
    pduExport: () => "PDU/Export",
    dimmsExport: () => "DeployedDimms/Export",
    disksExport: () => "Deployedphysdisk/Export",
    nicsExport: () => "Deployednic/Export",
    procsExport: () => "DeployedProc/Export",
    fpgasExport: () => "DeployedFPGAs/Export",
    tpmsExport: () => "DeployedTPMs/Export",
    getAllLeases: () => "BladeOwner/GetAll",
    bladeCheckIn: () => "Blade/CheckinBlade",
    bladeCheckOut: () => "Blade/CheckoutBlade",
    bladeExtend: () => "Blade/ExtendBlade",
    bladeTransfer: () => "Blade/TransferBlade",
    bladereset: () => "Blade/BladeReset",
    bladesCheckOut: () => "Blade/CheckoutBlades",
    bladesCheckIn: () => "Blade/CheckInBlades",
    bladesExtend: () => "Blade/ExtendBlades",
    bladesTransfer: () => "Blade/TransferBlades",
    baasRaasCheckOut: () => "Checkout",
    baasRaasCheckIn: () => "Checkin",
    baasRaasExtend: () => "Extend",
    baasRaasValidate: () => "Validate",
    baasRaasTransfer: () => "Transfer",
    benchReservation: () => "BenchReservation",
    sustaining: () => "SKU",
    getAllSustaining: () => "SKU/GetAll",
    getSustainingDetails: () => "SKU?bladeId=",
    sustainingEdit: () => "SKU?bladeId=",
    skuExport: () => "SKU/Export",
    getSustainingToolconfigExport: () => "SKU/GetSKUToolKitConfig",
    scanRM: () => "Scan/ScanRM",
    scanCM: () => "Scan/ScanCM",
    getHomeInfraCountView: () => "Home/GetHomeInfraCountView",
    getHomeSGNames: () => "Home/GetHomeSGNames",
    inventoryProject: () => "inventoryProject",
    getInventoryProjectDetails: () => "inventoryProject?id=",
    getAllColumns: () => "ColumnConfiguration/GetAll",
    saveColumns: () => "ColumnConfiguration",
    site: () => "site",
    getSite: () => "site/getAll",
    getSiteDetails: () => "site?id=",
    building: () => "building",
    getBuilding: () => "building/getAll",
    getBuildingDetails: () => "building?id=",
    manufacturerName: () => "manufacturerName",
    getManufacturerName: () => "manufacturerName/getAll",
    getManufacturerNameDetails: () => "manufacturerName?id=",
    getBenchNumberDetails: () => "DropDown/benchNumber",
    getLabNumberDetails: () => "DropDown/labNumber",
    getInventoryLeaseAuditDetails: () => "InventoryLeaseAudit/getLeaseAudit?inventoryid=",
    getUserDetailsByUserId: () => "InventoryLeaseAudit/getUserByUserId?id=",
    user: () => "user",
    dropdownData: (tableName: string) => `Dropdown/DropdownList/${tableName}`,
    dropdownDataUG: (userId: number) => `Dropdown/UserGroupsByUser/${userId}`,
    dropdownDataRackByDcId: (DcId: number) => `Dropdown/RacksByDc/${DcId}`,
    // getUserDetail: () => "user/getAll",
    // getUserDetailsbyId: () => "user?id=",
    getLeaseAudit: () => "InventoryLeaseAudit/getall",
    getLeaseAuditEport: () => "InventoryLeaseAudit/Export"


};
